import api from './api';

export default {
  login(credentials: any) {
    return api.post('/login', credentials);
  },
  register(userData: any) {
    return api.post('/register', userData);
  },
  logout() {
    return api.post('/logout');
  },
  me() {
    return api.get('/me');
  }
};
